import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import Disclaimer from '../Disclaimer';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class Xc47Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
		let imageOptions = exterior_view01ImageOptions;
        
        let image = (
			<TransomConfigurator colorMultiplier={0.75} name={this.props.configuration.transom.Name} port={this.props.configuration.transom.Port} transomSize={{ width: 2240, height: 1050  }} transform={
                [
					0.018568, 0.008687, 0, -0.000004,
					-0.001859, 0.048716, 0, -0.000021,
					0, 0, 1, 0,
					131, 292, 0, 1
                ]}>
                <ConfiguratorImage boat="Xc47" configuration={this.props.configuration.exterior} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

					<h1><Trans defaults='Summary' /></h1>
					<h2><Trans defaults='Congratulations!' /></h2>
					<p><Trans defaults='You have now configured the basics of an Xc47. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' /></p>

                    <PdfForm boat="Xc47" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />
                    
                    <ShareFrom configuration={this.props.configuration} boat="Xc47" code={this.props.code} />

                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Xc47Summary);


// WEBPACK FOOTER //
// ./src/Xc47/Xc47Summary.js